
import React from 'react';
import ProgressIndicator from '../ProgressIndicator';

const FormProgressIndicator: React.FC = () => {
  return <ProgressIndicator />;
};

export default FormProgressIndicator;
